export default "__VITE_ASSET__5b86328e__"